import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import BottomTab from '../LineTabs/BottomTab';
import InfoColorTab from '../LineTabs/Colored/InfoTab';
import PrimaryColorTab from '../LineTabs/Colored/PrimaryTab';
import SecondaryColorTab from '../LineTabs/Colored/SecondaryTab';
import SuccessColorTab from '../LineTabs/Colored/SuccessTab';
import LeftTab from '../LineTabs/LeftTab';
import RightTab from '../LineTabs/RightTab';
import Simple from '../LineTabs/Simple';

const TabLineContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Line Tabs' parent='Tabs' title='Line Tabs' />
      <Row>
        <Simple />
        <BottomTab />
        <LeftTab />
        <RightTab />
        <PrimaryColorTab />
        <SecondaryColorTab />
        <SuccessColorTab />
        <InfoColorTab />
      </Row>
    </Container>
  );
};

export default TabLineContainer;
